import styled from '@emotion/styled';
import SearchIcon from 'imagesUwKluis/svg/search.svg';
import ClearIcon from 'imagesUwKluis/svg/close-outline.svg';
import Input from './Input';
import {useTranslation} from "react-i18next";
import {FC} from "react";

interface SearchStyleType {
  width: SearchInputProps['width'];
}

const SearchStyle = styled.div<SearchStyleType>(({ theme: { colors }, width }) => ({
  position: 'relative',
  width,
  '> div > input': {
    height: '32px',
    padding: '8px 32px 8px 12px'
  },
  svg: {
    width: 16,
    height: 16,
    position: 'absolute',
    top: '8px',
    right: '8px',
    fill: colors?.secondaryButtonActive
  }
}));

interface SearchInputProps {
  value: string,
  onChange: (string) => void,
  width?: string | number,
  className?: string,
  placeholder?: string,
}

const SearchInput: FC<SearchInputProps> = ({ value, onChange, width = '100%', className, placeholder }) => {
  const { t } = useTranslation();
  return (
    <SearchStyle {...{ className, width }}>
      <Input
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder ? placeholder : t("Zoeken")}
        width={width}
        autoFocus
      />
      {value.length === 0 ? (
        <SearchIcon css={{ pointerEvents: 'none' }} />
      ) : (
        <ClearIcon onClick={() => onChange('')} css={{ cursor: 'pointer' }} />
      )}
    </SearchStyle>
  );
}

export default SearchInput;
